<template>
  <div class="page">
    <div
      class="card"
      :class="{ '-loading': loading }"
    >
      <div class="header">
        <div class="description">
          <h2 class="title">Histórico</h2>
          <p class="subtitle">Nesta tela você visualiza todo o histórico de consultas utilizadas. Clique sobre “Data de Utilização“ e “Tipo“ para fazer pesquisa por esses campos.</p>
        </div>
      </div>
      <div
        class="body"
        :class="{ '-no-padding': !errors.cantLoadUsesList }"
      >
        <div class="alert -danger" v-if="errors.cantLoadUsesList">
          <p class="title">Ops!</p>

          <p>
            Infelizmente aconteceu um erro ao tentar carregar o seu histórico,
            por favor tente novamente ou contate nossa equipe.
          </p>
        </div>

        <template v-if="!errors.cantLoadUsesList">
          <table class="history">
            <thead>
            <tr>
              <th class="-has-filter">
                <table-column-filter title="Data da Utilização">
                  <div class="form-group -sm w-full">
                    <label for="startDate" class="label">Data de Início</label>
                    <input
                      type="text"
                      id="startDate"
                      class="form-control"
                      v-mask="'##/##/####'"
                      placeholder="dd/mm/YYYY"
                      @input="updateFilterDateWhenCorrectly($event.target.value, 'start_date')"
                    >
                  </div>

                  <div class="form-group -sm w-full mb-0">
                    <label for="endDate" class="label">Data Final</label>
                    <input
                      type="text"
                      id="endDate"
                      class="form-control"
                      v-mask="'##/##/####'"
                      placeholder="dd/mm/YYYY"
                      @input="updateFilterDateWhenCorrectly($event.target.value, 'end_date')"
                    >
                  </div>
                </table-column-filter>
              </th>
              <th>Recurso</th>
              <th class="-has-filter">
                <table-column-filter title="Tipo">
                  <div class="form-group -sm w-full mb-0">
                    <label for="type" class="label">Tipo</label>
                    <select name="type" id="type" class="form-control" v-model="filters.type">
                      <option :value="null">Todos</option>
                      <option value="E">Estorno</option>
                      <option value="D">Débito</option>
                      <option value="C">Crédito</option>
                    </select>
                  </div>
                </table-column-filter>
              </th>
              <th class="-has-filter">Valor</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="use in uses.data">
              <td>{{ use.created_at | dateFormat('DD/MM/YY HH:mm') }}</td>
              <td class="-resource">{{ use.request_queue ? use.request_queue.endpoint_name : '' }}</td>
              <td><use-type-badge :type="use.type" /></td>
              <td>R$ {{ use.value | currency }}</td>
            </tr>
            </tbody>
          </table>

          <div class="navHistory">
            <pagination
              :limit="1"
              :data="uses"
              @pagination-change-page="page = $event"
            >
              <span slot="prev-nav">Anterior</span>
              <span slot="next-nav">Próxima</span>
            </pagination>
          </div>
        </template>

        <loader v-if="loading"></loader>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { pickBy } from 'lodash';
import { mask } from 'vue-the-mask';
import Pagination from 'laravel-vue-pagination';
import currency from '@/support/filters/currency';
import dateFormat from '@/support/filters/dateFormat';
import Loader from '@/support/components/Loader.vue';
import UseTypeBadge from '@/history/components/UseTypeBadge.vue';
import TableColumnFilter from '@/support/components/table/TableColumnFilter.vue';

export default {
  name: 'Index',

  data() {
    return {
      loading: false,
      page: 1,
      errors: {
        cantLoadUsesList: false,
      },
      filters: {
        type: null,
        start_date: null,
        end_date: null,
      },
    };
  },

  methods: {
    /**
     * Fetch the uses list.
     *
     * @returns {Promise<void>}
     */
    async fetchUsesList() {
      try {
        this.resetErrors();
        this.loading = true;

        const { page } = this;
        const filters = pickBy(this.filters, (value) => !!value);

        await this.$store.dispatch('history/fetchUsesList', { page, filters });
      } catch {
        this.errors.cantLoadUsesList = true;
      } finally {
        this.loading = false;
      }
    },

    /**
     * Reset the all errors to initial value.
     */
    resetErrors() {
      this.errors.cantLoadUsesList = false;
    },

    /**
     * Update the filter date when
     * value is correctly.
     *
     * @param value
     * @param date
     */
    updateFilterDateWhenCorrectly(value, date) {
      if (value.length === 0) {
        this.filters[date] = value;
      }

      if (value.length === 10) {
        this.filters[date] = value;
      }
    },
  },

  computed: {
    ...mapState('history', {
      uses: 'uses',
    }),
  },

  watch: {
    page() {
      this.fetchUsesList();
    },

    filters: {
      deep: true,
      handler() {
        this.fetchUsesList();
      },
    },
  },

  mounted() {
    this.fetchUsesList();
  },

  filters: {
    currency,
    dateFormat,
  },

  directives: {
    mask,
  },

  components: {
    Pagination,
    Loader,
    UseTypeBadge,
    TableColumnFilter,
  },
};
</script>

<style lang="scss" scoped>
  .page {
    > .card {
      > .body {
        > table.history {
          > tbody {
            > tr {
              > td {
                &.-resource {
                  @apply text-secondary-500;
                }
              }
            }
          }
        }

        > .navHistory {
          @apply flex;
          @apply justify-center;
        }
      }
    }
  }
</style>
